import { Ref } from "@tblabs/truffle";
import { CustomerAddress } from "./CustomerAddress";


export class CustomerInfo
{
    public Name = new Ref<string>("").Storable("customer-name");
    public Address = new CustomerAddress();
    public Email = new Ref<string>("").Storable("customer-email");
    public Phone = new Ref<string>("").Storable("customer-phone");
    public Experience = new Ref<number>(0).Storable("customer-experience");
    public DepositAccount = new Ref<string>("").Storable("customer-deposit-account");
    public Origin = new Ref<string>("").Storable("customer-origin");

    public get IsValid(): boolean
    {
        return this.Name.value.length > 0 && this.Address.AsString.length > 0 && this.Email.value.length > 0 && this.Phone.value.length > 0;
    }
}
